import type { CreatorStatusTab } from "../collaboration-table-columns";

type CollaborationKind = "target" | "open";

/**
 * Funnel row key (from the API) → creators-table status tab.
 *
 * The status-tab IDs aren't perfectly aligned between the two detail pages:
 *   - Target pages use `"posted_video"` for the "Generated GMV" tab.
 *   - Open pages use `"generated_gmv"` for the same tab.
 *   - Open pages have no `"invited"` tab at all.
 *
 * `funnelKeyToStatusTab` returns `null` when there's no matching tab for the
 * current page (the panel should treat that as "don't change the filter").
 */
export function funnelKeyToStatusTab(funnelKey: string, collaborationType: CollaborationKind): CreatorStatusTab | null {
  switch (funnelKey) {
    case "invited":
      // Open collabs don't surface an Invited status tab.
      return collaborationType === "target" ? "invited" : null;
    case "sample_requested":
      return "sample_requested";
    case "sample_status":
      return "sample_status";
    case "pending_post":
      return "pending_post";
    case "posted_no_gmv":
      return "posted_no_gmv";
    case "generated_gmv":
      return collaborationType === "target" ? "posted_video" : "generated_gmv";
    case "cancelled":
      return "cancelled";
    default:
      return null;
  }
}

/** Performance segment key → creators-table status tab. */
export function performanceKeyToStatusTab(
  segmentKey: string,
  collaborationType: CollaborationKind,
): CreatorStatusTab | null {
  switch (segmentKey) {
    case "generating_gmv":
      return collaborationType === "target" ? "posted_video" : "generated_gmv";
    case "generating_views":
      return "posted_no_gmv";
    case "not_posted":
      return "pending_post";
    default:
      return null;
  }
}

/** "Total GMV" summary tile maps to the "Generated GMV" status tab. */
export function totalGmvStatusTab(collaborationType: CollaborationKind): CreatorStatusTab {
  return collaborationType === "target" ? "posted_video" : "generated_gmv";
}
